// removed by extract-text-webpack-plugin
module.exports = {"list":"AdminUsersList__list__vW2ut","container":"AdminUsersList__container___aXXJ","header":"AdminUsersList__header__2XvcI","listItem":"AdminUsersList__listItem__wnBNz","avatar":"AdminUsersList__avatar__2fm6Z","avatarImage":"AdminUsersList__avatarImage__X8JDM","dob":"AdminUsersList__dob__2j6_e","gender":"AdminUsersList__gender__3Co8W","genderPreferences":"AdminUsersList__genderPreferences__2MKE7","reports":"AdminUsersList__reports__3qWfv","actions":"AdminUsersList__actions__TIz7M","button":"AdminUsersList__button__3WCgP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/UsersList/AdminUsersList.scss
// module id = 173
// module chunks = 0